/**
 * How a pivot is shown — the grid, or one of the chart types.
 * COUPLING: the values must match `PivotChartTypeEnum` in
 * apps/panelpunches/api-test/src/browser/support/page-objects/admin/PivotReportPage.ts,
 * which cannot import `@ztechapps`.
 */
export enum PivotChartTypeEnum {
  Grid = 'Grid',
  Column = 'Column',
  StackedColumn = 'StackedColumn',
  Pie = 'Pie',
  ColumnLine = 'ColumnLine',
}
